import { CardTypes, IPaymentMethod } from 'state/payment/types';

export const applePayCardDetails = {
  credit: {
    cardType: CardTypes.APPLE_PAY,
  },
  fdAccountId: CardTypes.APPLE_PAY,
  accountIdentifier: CardTypes.APPLE_PAY,
} as IPaymentMethod;
